export default __webpack_public_path__ + "images/0x1e4f97b9f9f913c46f1632781732927b9019c68b.png";